<div style="padding:24px 32px 0">
    <app-lun-snap-shot-base-info [item]="data"></app-lun-snap-shot-base-info>
</div>
